import { ReactElement, useCallback } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Typography } from 'antd';

import { ConfirmDeleteModal } from '@ohpen/enso-ui';
import { createDeleteErrorException } from '@pmp/utils';
import { ChangeRequestsDeleteModalProps } from '../interfaces';
import { changeRequestDelete } from '@pmp/api';

const { Text } = Typography;

export const ChangeRequestsDeleteModal = ({ open, record, onClose, refreshTable }: ChangeRequestsDeleteModalProps): ReactElement => {
  const { t } = useTranslation();
  const { actionId } = record || {};
  // const name = '';  TODO add description  or name to change request
  const name = record?.actionId;

  const onConfirmDelete = useCallback(() => {
    return actionId
      ? changeRequestDelete({ path: { changeRequestId: actionId } })
          .then(() => {
            onClose();
            refreshTable();
            return { description: t('enso.notifications.xDeletedSuccessfully', { x: t('global.labels.changeRequest') }) };
          })
          .catch(error => {
            onClose();
            return Promise.reject(createDeleteErrorException(error));
          })
      : Promise.reject(createDeleteErrorException({ title: t('enso.errors.invalidRecord') }));
  }, [actionId, onClose, refreshTable, t]);

  return (
    <ConfirmDeleteModal
      title={t('enso.labels.deleteX', { x: t('global.labels.changeRequest') })}
      open={open}
      onConfirm={onConfirmDelete}
      onCancel={onClose}
    >
      <Text>
        <Trans i18nKey="global.labels.confirmDeleteX" values={{ x: name }} components={{ italic: <i /> }} />
      </Text>
    </ConfirmDeleteModal>
  );
};
